import { IBaseProps } from '@did/types'
import React from 'react'
import { NotFound, TransStatusDialog } from '@did/das-balance-components'
import { useDasBalanceContext } from '@did/das-app-context'
import { useAvailableBalance } from '@did/das-balance-hooks'
import { useBalanceAction } from '@did/das-balance-hooks/src/use-balance-action'
import { ActionDialog } from './action-dialog'
import { ActivateInfo } from './activate-info'
import { AvailableBalance } from './available-balance'
import { MyAccountList } from './my-account-list'

export const HomeIndex: React.FC<IBaseProps> = () => {
  const { tt } = useDasBalanceContext()
  const { availableBalance, balanceUSD, transitBalance, fetchBalance } =
    useAvailableBalance()

  const {
    handleActionSuccess,
    receiveShow,
    setReceiveShow,
    sendShow,
    setSendShow,
    transferSubmittedDialogShowing,
    handleSubmittedDialogClose,
    txHash,
    txHashLink,
    actionList
  } = useBalanceAction({ onSucess: fetchBalance })

  return (
    <>
      <h3 className="text-base mx-4 mb-1 mt-8 text-center font-bold">
        {tt('Lightweight and decentralized CKB balance management tool')}
      </h3>
      <div className="text-sm mx-4 mb-6  opacity-30 text-center">
        {tt('Effortless CKB Tracking')}
      </div>
      <div className="mx-auto px-3 sm:px-0 w-full md:w-[33rem] mb-6">
        <AvailableBalance
          className="shadow-sm border border-gray-200 bg-white sm:p-6 p-4 rounded-3xl"
          ActivateInfo={(props) => {
            return (
              <ActivateInfo {...props} successCallback={handleActionSuccess} />
            )
          }}
          availableBalance={availableBalance}
          balanceUSD={balanceUSD}
          transitBalance={transitBalance}
          onReceiveClick={() => {
            setReceiveShow(true)
          }}
          onSendClick={() => {
            setSendShow(true)
          }}
        />
        <div className="shadow-sm border border-gray-200 bg-white rounded-3xl mt-3">
          <div className=" text-base font-bold pb-3  p-4 sm:p-6">
            {tt('History')}
          </div>
          <MyAccountList
            balance={availableBalance}
            className=" px-0 sm:px-2"
            NotFound={NotFound}
          />
        </div>
        <ActionDialog
          availableBalance={availableBalance}
          receiveShow={receiveShow}
          sendShow={sendShow}
          onReceiveShowChange={setReceiveShow}
          onSendShowChange={setSendShow}
          successCallback={handleActionSuccess}
        />
        <TransStatusDialog
          txHash={txHash}
          txHashLink={txHashLink}
          showing={transferSubmittedDialogShowing}
          onClose={handleSubmittedDialogClose}
          actions={actionList}
        />
      </div>
    </>
  )
}
